import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import { cohortColumnDefs, cohortDefaultColDef } from './definitions-config';
import { IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

function CohortTable({ rowData, editHandler }) {
  const ButtonRenderer = (params) => {
    return (
      <div className='flex justify-left items-center'>
        <IconButton onClick={() => editHandler(params.data)}>
          <EditIcon />
        </IconButton>
      </div>
    );
  };

  const frameworkComponents = {
    btnCellRenderer: ButtonRenderer,
  };

  return (
    <div className='ag-theme-alpine' style={{ height: '75vh', width: '100%' }}>
      <AgGridReact
        columnDefs={cohortColumnDefs}
        defaultColDef={cohortDefaultColDef}
        rowData={rowData || []}
        tooltipShowDelay={0}
        tooltipHideDelay={2000}
        pagination={true}
        paginationPageSize={10}
        paginationAutoPageSize={true}
        onGridReady={(params) => {
          params.api.sizeColumnsToFit();
        }}
        onGridSizeChanged={(params) => {
          params.api.sizeColumnsToFit();
        }}
        frameworkComponents={frameworkComponents}
      />
    </div>
  );
}

export default CohortTable;
